import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="site-footer">
        {/* ── Acknowledgment of Country ── */}
        <div className="footer-acknowledgment">
          <div className="footer-acknowledgment-accent" aria-hidden="true" />
          <div className="footer-acknowledgment-inner">
            <img className="footer-acknowledgment-icon" src="/Images/BG_Images/aboriginalfag.png" alt="Aboriginal Flag" draggable="false" />
            <p className="footer-acknowledgment-text">
              We at NextXR Group acknowledge Aboriginal and Torres Strait Islander people as the first peoples and Traditional Owners and custodians of the land and waterways on which we live. We honour and pay our respects to elders past and present.
            </p>
          </div>
        </div>

        {/* ── Main footer content ── */}
        <div className="footer-inner">
          {/* Brand column */}
          <div className="footer-brand">
            <Link className="footer-logo" to="/" aria-label="NextXR Group home">
              <img src="/Images/Website_Logo/NextXR.png" alt="NextXR Group" />
            </Link>

            <p className="footer-tagline">
              Building intelligent worlds. Simulating real possibilities.
            </p>

            <p className="footer-description">
              Next XR Group is an AI, Digital Twin, Extended Reality and
              simulation technology company developing intelligent enterprise
              solutions for manufacturing, construction, healthcare, education,
              defence and critical industries.
            </p>

            <div className="footer-socials">
              <a className="footer-social" href="https://www.linkedin.com/company/nextxrgroup/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <img src="/Images/Icons/footerlinkedin.png" alt="LinkedIn" />
              </a>
              <a className="footer-social" href="https://www.facebook.com/nextxrgroup/" target="_blank" rel="noreferrer" aria-label="Facebook">
                <img src="/Images/Icons/footerfacebook.png" alt="Facebook" />
              </a>
              <a className="footer-social" href="https://www.instagram.com/nextxrgroupau/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <img src="/Images/Icons/footerinstagram.png" alt="Instagram" />
              </a>
              <a className="footer-social" href="https://www.youtube.com/@NextXRGroup" target="_blank" rel="noreferrer" aria-label="YouTube">
                <img src="/Images/Icons/footeryoutube.svg" alt="YouTube" />
              </a>
            </div>
          </div>

          {/* Company links */}
          <nav className="footer-column" aria-label="Company">
            <h3>Company</h3>
            <ul>
              <li><a href="/#partners">Partners</a></li>
              <li><a href="/#clients">Clients</a></li>
              <li><a href="/awards">Award Records</a></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>

          {/* Capabilities */}
          <div className="footer-capabilities">
            <h3>Capabilities</h3>
            <div className="footer-cap-grid">
              <ul>
                <li>AI-Powered Digital Twins</li>
                <li>Extended Reality Solutions</li>
                <li>Enterprise AI Agents</li>
                <li>Intelligent Simulation Engines</li>
                <li>Drone Simulators</li>
                <li>SaaS Solutions</li>
              </ul>
              <ul>
                <li>Mixed Reality</li>
                <li>IoT Integration</li>
                <li>Intelligent Operational Platforms</li>
                <li>Web & Mobile Application</li>
              </ul>
            </div>
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div className="footer-bottom">
          <p className="footer-bottom-tagline">
            Next XR Group — <strong>Building Intelligent Worlds. Simulating Real Possibilities.</strong>
          </p>
          <div className="footer-bottom-right">
            <div className="footer-legal">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              
            </div>
            <p className="footer-copy">© 2026 Next XR Group. All rights reserved.</p>
          </div>
        </div>

        {/* Purple glow at the bottom */}
        <div className="footer-glow" aria-hidden="true" />
      </footer>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap');

        .site-footer {
          position: relative;
          padding: 72px 60px 0;
          background: #020206;
          color: #f0edff;
          font-family: 'DM Sans', sans-serif;
          overflow: hidden;
        }

        .site-footer::before {
          content: '';
          position: absolute;
          top: -120px;
          left: -150px;
          width: 420px;
          height: 420px;
          background: radial-gradient(circle, rgba(123,47,224,1) 0%, rgba(155,77,255,0.06) 40%, transparent 70%);
          border-radius: 50%;
          pointer-events: none;
          filter: blur(40px);
        }

        /* ── Acknowledgment of Country ── */
        .footer-acknowledgment {
          position: relative;
          margin: -72px -60px 72px;
          background: linear-gradient(180deg, rgba(155,77,255,0.04) 0%, transparent 100%);
          border-bottom: 1px solid rgba(155,77,255,0.08);
        }

        .footer-acknowledgment-accent {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(90deg, transparent 0%, rgba(123,47,224,0.5) 25%, rgba(155,77,255,0.8) 50%, rgba(123,47,224,0.5) 75%, transparent 100%);
        }

        .footer-acknowledgment-inner {
          max-width: 900px;
          margin: 0 auto;
          padding: 28px 30px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 10px;
        }

        .footer-acknowledgment-icon {
          display: block;
          width: 406px;
          height: auto;
          object-fit: contain;
          border: 4px solid #9B4DFF;
          padding : 20px;
          border-radius: 15px;
          background: #ffffffe3;

        }

        .footer-acknowledgment-text {
          margin: 0;
          color: #9B4DFF;
          font-size: 20px;
          font-weight: 500;
          line-height: 1.8;
          font-family: 'Poppins', sans-serif;
          letter-spacing: 0.01em;
        }

        .footer-inner {
          display: grid;
          grid-template-columns: 1.2fr 0.6fr 1.6fr;
          column-gap: 64px;
          max-width: 1280px;
          margin: 0 auto;
          padding-bottom: 48px;
        }

        /* ── Brand ── */
        .footer-brand {
          max-width: 400px;
        }

        .footer-logo {
          display: inline-flex;
          align-items: center;
          text-decoration: none;
        }

        .footer-logo img {
          display: block;
          width: auto;
          height: 100px;
        }

        .footer-tagline {
          margin: 16px 0 0;
          color: #9B4DFF;
          font-size: 14px;
          font-weight: 400;
          line-height: 1.5;
          font-family: 'Poppins', 'sans-serif';
        }

        .footer-description {
          margin: 20px 0 0;
          color: rgba(240,237,255,0.5);
          font-size: 13.5px;
          font-weight: 300;
          line-height: 1.75;
          max-width: 360px;
          font-family: 'Poppins', 'sans-serif';
        }

        .footer-socials {
          display: flex;
          gap: 14px;
          margin-top: 28px;
        }

        .footer-social {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .footer-social:hover {
          border-color: rgba(155,77,255,0.6);
          background: rgba(155,77,255,0.15);
          transform: translateY(-2px);
        }

        .footer-social img {
          width: 38px;
          height: 38px;
          object-fit: contain;
          opacity: 0.8;
          transition: opacity 0.3s;
        }

        .footer-social:hover img {
          opacity: 1;
        }

        /* ── Link columns ── */
        .footer-column {
          padding-top: 8px;
        }

        .footer-column h3 {
          margin: 0 0 24px;
          color: #9B4DFF;
          font-family: 'Syne', sans-serif;
          font-size: 18px;
          font-weight: 700;
          letter-spacing: 0.02em;
        }

        .footer-column ul {
          display: flex;
          flex-direction: column;
          gap: 18px;
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .footer-column a {
          color: rgba(240,237,255,0.55);
          font-size: 14px;
          font-weight: 400;
          line-height: 1.3;
          text-decoration: none;
          transition: color 0.25s ease;
        }

        .footer-column a:hover {
          color: #ffffff;
        }

        /* ── Capabilities ── */
        .footer-capabilities {
          padding-top: 8px;
        }

        .footer-capabilities h3 {
          margin: 0 0 24px;
          color: #9B4DFF;
          font-family: 'Syne', sans-serif;
          font-size: 18px;
          font-weight: 700;
          letter-spacing: 0.02em;
        }

        .footer-cap-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px 40px;
        }

        .footer-cap-grid ul {
          display: flex;
          flex-direction: column;
          gap: 18px;
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .footer-cap-grid li {
          color: rgba(240,237,255,0.5);
          font-size: 14px;
          font-weight: 300;
          line-height: 1.4;
          transition: color 0.25s;
          cursor: default;
        }

        .footer-cap-grid li:hover {
          color: rgba(240,237,255,0.85);
        }

        /* ── Bottom bar ── */
        .footer-bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          max-width: 1280px;
          margin: 0 auto;
          padding: 20px 0;
          border-top: 1px solid rgba(155,77,255,0.1);
          flex-wrap: wrap;
          gap: 16px;
        }

        .footer-bottom-tagline {
          margin: 0;
          color: rgba(240,237,255,0.35);
          font-size: 15px;
          font-weight: 300;
          font-family: 'Poppins', 'sans-serif';
        }

        .footer-bottom-tagline strong {
          font-weight: 600;
          color: rgba(240,237,255,0.5);
        }

        .footer-bottom-right {
          display: flex;
          align-items: center;
          gap: 40px;
          flex-wrap: wrap;
        }

        .footer-legal {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 15px;
        }

        .footer-legal a,
        .footer-legal span {
          color: #ffffff60;
          text-decoration: none;
          transition: color 0.25s;
          cursor: pointer;
        }

        .footer-legal a:hover,
        .footer-legal span:hover {
          color: #ffffff;
        }

        .footer-legal a::before,
        .footer-legal span::before {
          content: '•';
          margin-right: 6px;
          color: rgba(240,237,255,0.25);
        }

        .footer-copy {
          margin: 0;
          color: rgba(240,237,255,0.3);
          font-size: 15px;
          font-weight: 300;
          font-family: 'Poppins', 'sans-serif';
        }

        /* ── Bottom glow ── */
        .footer-glow {
          position: absolute;
          bottom: -2px;
          left: 50%;
          transform: translateX(-50%);
          width: 70%;
          height: 3px;
          background: linear-gradient(90deg, transparent 0%, rgba(123,47,224,0.6) 30%, rgba(155,77,255,0.9) 50%, rgba(123,47,224,0.6) 70%, transparent 100%);
          border-radius: 2px;
          filter: blur(1px);
          pointer-events: none;
        }

        .footer-glow::before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 10%;
          right: 10%;
          height: 40px;
          background: radial-gradient(ellipse at center bottom, rgba(123,47,224,0.15), transparent 70%);
          filter: blur(20px);
          pointer-events: none;
        }

        /* ── Responsive ── */
        /* Refined mobile footer layout */
@media (max-width: 1024px) {
.site-footer {
padding: 56px 28px 0;
}

.footer-acknowledgment {
margin: -56px -28px 56px;
}

.footer-acknowledgment-inner {
padding: 24px 28px;
}

.footer-inner {
grid-template-columns: 1fr 1fr;
column-gap: 28px;
row-gap: 40px;
align-items: start;
text-align: left;
}

.footer-brand {
grid-column: 1 / -1;
max-width: 100%;
text-align: left;
}

.footer-column,
.footer-capabilities {
padding-top: 0;
text-align: left;
}

.footer-capabilities {
grid-column: 1 / -1;
}

.footer-cap-grid {
grid-template-columns: 1fr 1fr;
gap: 14px 28px;
}

.footer-bottom {
align-items: flex-start;
justify-content: space-between;
text-align: left;
}

.footer-bottom-right {
justify-content: flex-start;
align-items: flex-start;
gap: 12px;
}
}

@media (max-width: 768px) {
.site-footer {
padding: 46px 20px 0;
}

.footer-acknowledgment {
margin: -46px -20px 46px;
}

.footer-acknowledgment-inner {
padding: 22px 20px;
max-width: 100%;
}

.footer-acknowledgment-text {
font-size: 12px;
line-height: 1.75;
}

.site-footer::before {
width: 260px;
height: 260px;
top: -90px;
left: -120px;
filter: blur(34px);
}

.footer-inner {
grid-template-columns: 1fr;
row-gap: 30px;
padding-bottom: 28px;
text-align: left;
}

.footer-brand,
.footer-column,
.footer-capabilities {
grid-column: auto;
max-width: 100%;
text-align: left;
}

.footer-logo {
justify-content: flex-start;
}

.footer-logo img {
height: 60px;
}

.footer-tagline {
margin-top: 12px;
font-size: 13px;
line-height: 1.55;
max-width: 100%;
}

.footer-description {
margin-top: 14px;
font-size: 12.8px;
line-height: 1.7;
max-width: 100%;
}

.footer-socials {
justify-content: flex-start;
gap: 10px;
margin-top: 22px;
flex-wrap: wrap;
}

.footer-social {
width: 46px;
height: 46px;
}

.footer-social img {
width: 26px;
height: 26px;
}

.footer-column h3,
.footer-capabilities h3 {
margin: 0 0 16px;
font-size: 16px;
line-height: 1.2;
}

.footer-column ul,
.footer-cap-grid ul {
gap: 12px;
}

.footer-column a,
.footer-cap-grid li {
font-size: 13px;
line-height: 1.5;
}

.footer-cap-grid {
grid-template-columns: 1fr;
/* Same spacing as between list items, so the two stacked lists read as one. */
gap: 12px;
}

.footer-bottom {
flex-direction: column;
align-items: flex-start;
justify-content: flex-start;
gap: 10px;
padding: 18px 0 22px;
}

.footer-bottom-tagline {
font-size: 12.8px;
line-height: 1.6;
text-align: left;
}

.footer-bottom-right {
width: 100%;
flex-direction: column;
align-items: flex-start;
justify-content: flex-start;
gap: 10px;
}

.footer-legal {
width: 100%;
justify-content: flex-start;
flex-wrap: wrap;
gap: 8px 10px;
font-size: 12.8px;
}

.footer-copy {
font-size: 12.8px;
line-height: 1.5;
text-align: left;
}
}

@media (max-width: 480px) {

.footer-acknowledgment-icon { width: 220px; padding: 5px; border: 1px; border-radius: 5px;}

.site-footer {
padding: 38px 16px 0;
}

.footer-acknowledgment {
margin: -38px -16px 38px;
}

.footer-acknowledgment-inner {
padding: 18px 16px;
}

.footer-acknowledgment-text {
font-size: 11.5px;
line-height: 1.7;
}

.footer-column { 
padding: 0px;
}

.footer-inner {
row-gap: 26px;
}

.footer-logo img {
height: 54px;
}

.footer-tagline {
font-size: 12.5px;
}

.footer-description {
font-size: 12.3px;
}

.footer-socials {
gap: 8px;
}

.footer-social {
width: 42px;
height: 42px;
}

.footer-social img {
width: 22px;
height: 22px;
}

.footer-column h3,
.footer-capabilities h3 {
font-size: 15px;
margin-bottom: 14px;
}

.footer-column a,
.footer-cap-grid li,
.footer-bottom-tagline,
.footer-copy,
.footer-legal {
font-size: 12.2px;
}

.footer-bottom {
padding: 16px 0 20px;
}
}

@media (max-width: 360px) {
.site-footer {
padding: 34px 14px 0;
}

.footer-acknowledgment {
margin: -34px -14px 34px;
}

.footer-acknowledgment-inner {
padding: 16px 14px;
}

.footer-logo img {
height: 48px;
}

.footer-social {
width: 38px;
height: 38px;
}

.footer-social img {
width: 20px;
height: 20px;
}

.footer-column ul,
.footer-cap-grid ul {
gap: 10px;
}

.footer-column a,
.footer-cap-grid li {
font-size: 11.8px;
}
}

      `}</style>
    </>
  );
};

export default Footer;